module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2020/august-b5ea255c747aea50f0f2082d8a028956.png";